<template>
  <div style="max-width: 350px">
    <!--指导老师    -->
    <div style="color: black">
      <span>{{ $t("competitionList.mentor") }}: </span>
      <!--  展示状态    -->
      <span v-if="!mentorEditMode">
        <span v-if="mentorList.length === 0">{{ $t("common.null") }}</span>
        <span v-else v-for="(m, i) in mentorList" :key="i">
          {{ m.name }};
        </span>
        <el-button
          type="text"
          @click="handleStartEdit(1)"
          class="edit_icon"
          v-if="mentorEditable"
          size="medium"
        >
          <i class="el-icon-edit"></i>
        </el-button>
      </span>
      <!--   修改状态   -->
      <div v-else style="margin-top: 6px">
        <el-form :model="mentorForm" ref="mentorForm" size="mini">
          <div v-for="(item, index) in mentorForm.mentorData" :key="item.key">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-form-item
                  :prop="'mentorData.' + index + '.name'"
                  :rules="{
                    required: true,
                    trigger: ['blur', 'change'],
                    message: $t('common.notNull'),
                  }"
                >
                  <el-input
                    v-model="item.name"
                    :placeholder="$t('competitionList.name')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :prop="'mentorData.' + index + '.email'"
                  :rules="[
                    {
                      required: true,
                      message: $t('common.notNull'),
                      trigger: ['blur', 'change'],
                    },
                    {
                      type: 'email',
                      message: $t('competitionList.emailFormat'),
                      trigger: ['blur', 'change'],
                    },
                  ]"
                >
                  <el-input
                    v-model="item.email"
                    :placeholder="$t('competitionList.email')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <i
                  class="el-icon-delete"
                  style="font-size: 16px"
                  @click="handleRemove(1, index)"
                ></i>
              </el-col>
            </el-row>
          </div>
          <!--  按钮  -->
          <div>
            <el-button style="padding-top: 0" @click="handleAdd(1)" type="text">
              <i class="el-icon-plus"></i>
              {{ $t("button.add") }}
            </el-button>
            <el-button
              style="padding-top: 0"
              @click="handleSave(1)"
              type="text"
            >
              <i class="el-icon-check"></i>
              {{ $t("button.save") }}
            </el-button>
            <el-button
              style="padding-top: 0"
              @click="handleCancel(1)"
              type="text"
            >
              <i class="el-icon-close"></i>
              {{ $t("button.cancel") }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
    <!--成员    -->
    <div v-if="isTeam" style="color: black">
      <span>{{ $t("competitionList.teammate") }}: </span>
      <!--  展示状态    -->
      <span v-if="!memberEditMode">
        <span v-if="memberList.length === 0">{{ $t("common.null") }}</span>
        <span v-else v-for="(m, i) in memberList" :key="i">
          {{ m.name }};
        </span>
        <el-button
          type="text"
          @click="handleStartEdit(2)"
          class="edit_icon"
          v-if="memberEditable"
          size="medium"
        >
          <i class="el-icon-edit"></i>
        </el-button>
      </span>
      <!--   修改状态   -->
      <div v-else style="margin-top: 6px">
        <el-form :model="memberForm" ref="memberForm" size="mini">
          <div v-for="(item, index) in memberForm.memberData" :key="item.key">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-form-item
                  :prop="'memberData.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: $t('common.notNull'),
                    trigger: ['blur', 'change'],
                  }"
                >
                  <el-input
                    v-model="item.name"
                    :placeholder="$t('competitionList.name')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :prop="'memberData.' + index + '.email'"
                  :rules="[
                    {
                      required: true,
                      message: $t('common.notNull'),
                      trigger: ['blur', 'change'],
                    },
                    {
                      type: 'email',
                      message: $t('competitionList.emailFormat'),
                      trigger: ['blur', 'change'],
                    },
                  ]"
                >
                  <el-input
                    v-model="item.email"
                    :placeholder="$t('competitionList.email')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <i
                  class="el-icon-delete"
                  style="font-size: 16px"
                  @click="handleRemove(2, index)"
                ></i>
              </el-col>
            </el-row>
          </div>
          <!--  按钮  -->
          <div>
            <el-button style="padding-top: 0" @click="handleAdd(2)" type="text">
              <i class="el-icon-plus"></i>
              {{ $t("button.add") }}
            </el-button>
            <el-button
              style="padding-top: 0"
              @click="handleSave(2)"
              type="text"
            >
              <i class="el-icon-check"></i>
              {{ $t("button.save") }}
            </el-button>
            <el-button
              style="padding-top: 0"
              @click="handleCancel(2)"
              type="text"
            >
              <i class="el-icon-close"></i>
              {{ $t("button.cancel") }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateMentor, updateTeammates } from "../../api/competition";

export default {
  name: "teamEdit",
  props: {
    participants: {
      type: Array,
    },
    memberLimit: {
      type: Number,
      default: 2,
    },
    mentorLimit: {
      type: Number,
      default: 1,
    },
    isTeam: {
      type: Boolean,
      default: false,
    },
    qualificationId: {
      type: [Number, String],
      default: 1,
    },
    mentorEditable: {
      type: Boolean,
      default: true,
    },
    memberEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mentorEditMode: false,
      memberEditMode: false,
      mentorList: [],
      memberList: [],
      mentorForm: { mentorData: [] },
      memberForm: { memberData: [] },
    };
  },
  mounted() {
    this.getMentorList();
    this.getMemberList();
  },
  methods: {
    getMentorList() {
      this.mentorList = [];
      let l = this.participants.length - 1;
      for (; l >= 0; l--) {
        if (this.participants[l].addonsType === 0) {
          this.mentorList.push({
            name: this.participants[l].name,
            email: this.participants[l].email,
          });
        }
      }
    },
    getMemberList() {
      this.memberList = [];
      let l = this.participants.length - 1;
      for (; l >= 0; l--) {
        if (this.participants[l].addonsType === 1) {
          this.memberList.push({
            name: this.participants[l].name,
            email: this.participants[l].email,
          });
        }
      }
    },
    //取消编辑
    handleCancel(i) {
      if (i === 1) {
        this.mentorEditMode = false;
        this.getMentorList();
      } else {
        this.memberEditMode = false;
        this.getMemberList();
      }
    },
    //开始编辑 1 指导老师; 2 队员
    handleStartEdit(i) {
      if (i === 1) {
        this.mentorForm.mentorData = this.mentorList;
        if (this.mentorList.length === 0) {
          this.mentorList.push({ name: "", email: "" });
        }
        this.mentorEditMode = true;
      } else {
        this.memberForm.memberData = this.memberList;
        if (this.memberList.length === 0) {
          this.memberList.push({ name: "", email: "" });
        }
        this.memberEditMode = true;
      }
    },
    // 保存修改
    handleSave(i) {
      let that = this;
      if (i === 1) {
        that.$refs["mentorForm"].validate((valid) => {
          if (valid) {
            let mentorListNew = [];
            that.mentorForm.mentorData.map((item, index) => {
              mentorListNew.push(
                Object.assign(item, {
                  qualificationId: that.qualificationId,
                  addonsType: 0,
                }),
              );
            });
            console.log(mentorListNew);
            updateMentor(that.qualificationId, mentorListNew).then((res) => {
              that.$notify({
                type: "success",
                title: that.$t("common.success"),
                duration: 3000,
                message: "",
              });
              that.update_team();
              this.mentorEditMode = false;
            });
          } else {
            that.$notify({
              type: "warning",
              title: that.$t("common.error"),
              duration: 3000,
              message: that.$t("common.formatInfo"),
            });
          }
        });
      } else {
        that.$refs["memberForm"].validate((valid) => {
          if (valid) {
            let memberListNew = [];
            that.memberForm.memberData.map((item, index) => {
              memberListNew.push(
                Object.assign(item, {
                  qualificationId: that.qualificationId,
                  addonsType: 1,
                }),
              );
            });
            //todo
            updateTeammates(that.qualificationId, memberListNew).then((res) => {
              let msg =
                that.$i18n.locale !== "en" ? res.message : res.messageEng;
              if (res.code === 0) {
                that.$notify({
                  type: "success",
                  title: that.$t("common.success"),
                  duration: 3000,
                  message: "",
                });
                this.memberEditMode = false;
                that.update_team();
              } else {
                that.$notify({
                  type: "error",
                  title: that.$t("common.fail"),
                  duration: 3000,
                  message: msg,
                });
              }
            });
          } else {
            that.$notify({
              type: "warning",
              title: that.$t("common.error"),
              duration: 3000,
              message: that.$t("common.formatInfo"),
            });
          }
        });
      }
    },
    //todo debug
    //动态增加表项
    handleAdd(i) {
      let that = this;
      if (i === 1) {
        if (this.mentorForm.mentorData.length >= this.mentorLimit) {
          this.$notify({
            type: "error",
            title: that.$t("competitionList.numberLimit", {
              n: that.mentorLimit,
            }),
            duration: 3000,
            message: "",
          });
        } else {
          this.mentorForm.mentorData.push({ name: "", email: "" });
        }
      } else {
        if (this.memberForm.memberData.length >= this.memberLimit) {
          this.$notify({
            type: "error",
            title: that.$t("competitionList.numberLimit", {
              n: that.memberLimit,
            }),
            duration: 3000,
            message: "",
          });
        } else {
          this.memberForm.memberData.push({ name: "", email: "" });
        }
      }
    },
    //动态减少表项
    handleRemove(i, index) {
      if (i === 1) {
        this.mentorForm.mentorData.splice(index, 1);
      } else {
        this.memberForm.memberData.splice(index, 1);
      }
    },
    update_team() {
      this.$emit("update_team");
    },
  },
};
</script>

<style scoped>
.edit_icon {
  float: right;
  padding-top: 2px;
  padding-bottom: 0;
  padding-right: 100px;
}
</style>
